<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item>
              <!-- 关键字搜索 -->
              <a-input v-model="queryParam.keyWord" placeholder="请输入关键字">
                <!-- 选择搜索类型 -->
                <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
                  <a-select-option :value="keyword.id" :key="keyword.id" v-for="keyword in dict.keyWordTypeList">{{ keyword.name }}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-range-picker :value="time" format="YYYY-MM-DD" @change="onChangeTime" :placeholder="['申请开始日期','申请结束日期']" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item title="提现金额">
              <div style="display: flex;">
                <a-input placeholder="提现金额" disabled style="width: 80px;text-align: center;"></a-input>
                <a-input style="width: 140px;" v-model="queryParam.start_money" addon-after="元至"></a-input>
                <a-input style="width: 120px;" v-model="queryParam.end_money" addon-after="元"></a-input>
              </div>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="clickOrderOutExcel" style="margin-left: 8px">导出</a-button>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      rowKey="tenant_id"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="bank" slot-scope="text, record">
        {{ record.card_owner }}<br/>
        {{ record.bank }} {{ record.bank_branch }}<br/>
        {{ record.bank_card_number }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="openModal(record)" v-if="record.status==='DONE'">已转账详情</a>
          <a @click="openSetDoneModal(record)" v-if="record.status==='NORMAL'">已转账</a>
          <a-divider type="vertical" v-if="record.status === 'NORMAL'"/>
          <a @click="openSetRefuseModal(record)" v-if="record.status==='NORMAL'">拒绝提现</a>
          <a @click="openRefuseModal(record)" v-if="record.status==='REFUSE'">拒绝理由</a>
        </template>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 已转账详情 -->
    <a-modal
      title="已转账详情"
      :visible="doneShow"
      @ok="doneShow = false"
      @cancel="doneShow = false"
      :footer="null"
    >
      <p>转账银行：{{ item.bank }}</p>
      <p>银行卡号：{{ item.bank_card_number }}</p>
      <p>所属支行：{{ item.bank_branch }}</p>
      <p>持卡人姓名：{{ item.card_owner }}</p>
      <p>提现金额￥：{{ item.money }}</p>
      <p>转账时间：{{ item.examine_time }}</p>
      <p>备注：{{ item.remark }}</p>
    </a-modal>
    <!-- 已转账操作 -->
    <a-modal
      title="已转账操作"
      :visible="setDoneShow"
      @ok="setDone"
      @cancel="setDoneShow = false"
    >
      <p>转账银行：{{ item.bank }}</p>
      <p>银行卡号：{{ item.bank_card_number }}</p>
      <p>所属支行：{{ item.bank_branch }}</p>
      <p>持卡人姓名：{{ item.card_owner }}</p>
      <p>提现金额￥：{{ item.money }}</p>
      <p><a-textarea placeholder="转账备注" :rows="3" v-model="item.setRemark"/></p>
    </a-modal>
    <!-- 拒绝转账操作 -->
    <a-modal
      title="拒绝转账操作"
      :visible="setRefuseShow"
      @ok="setRefuse"
      @cancel="setRefuseShow = false"
    >
      <p>转账银行：{{ item.bank }}</p>
      <p>银行卡号：{{ item.bank_card_number }}</p>
      <p>所属支行：{{ item.bank_branch }}</p>
      <p>持卡人姓名：{{ item.card_owner }}</p>
      <p>提现金额￥：{{ item.money }}</p>
      <p><a-textarea placeholder="拒绝理由" :rows="3" v-model="item.setRemark"/></p>
    </a-modal>
    <!-- 已拒绝详情 -->
    <a-modal
      title="已拒绝详情"
      :visible="refuseShow"
      @ok="refuseShow = false"
      @cancel="refuseShow = false"
      :footer="null"
    >
      <p>转账银行：{{ item.bank }}</p>
      <p>银行卡号：{{ item.bank_card_number }}</p>
      <p>所属支行：{{ item.bank_branch }}</p>
      <p>持卡人姓名：{{ item.card_owner }}</p>
      <p>提现金额￥：{{ item.money }}</p>
      <p>拒绝时间：{{ item.examine_time }}</p>
      <p>拒绝理由：{{ item.remark }}</p>
    </a-modal>
  </a-card>
</template>
<script>
import {
  getPre,
  getList,
  examine
} from '@/api/withdrawal'
import { TcgTable } from '@/components'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: {
    TcgTable
  },
  data () {
    return {
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        status: '',
        keyWordType: 'tenant_name',
        keyWord: '',
        start_time: '',
        end_time: '',
        start_money: '',
        end_money: ''
      },
      // 表头
      columns: [
        {
          title: '提现单号',
          dataIndex: 'withdrawalId'
        },
        {
          title: '申请时间',
          dataIndex: 'create_time'
        },
        {
          title: '申请商家',
          dataIndex: 'tenant_name'
        },
        {
          title: '提现至',
          dataIndex: 'bank',
          scopedSlots: { customRender: 'bank' }
        },
        {
          title: '提现金额（元）',
          dataIndex: 'money'
        },
        {
          title: '手续费（元）',
          dataIndex: 'service_charge'
        },
        {
          title: '到账金额（元）',
          dataIndex: 'arrival_money'
        },
        {
          title: '剩余金额',
          dataIndex: 'balance'
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '150px'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      time: [],
      item: {},
      doneShow: false,
      setDoneShow: false,
      setRefuseShow: false,
      refuseShow: false
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    moment,
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: '',
        keyWordType: 'tenant_name',
        keyWord: '',
        start_time: '',
        end_time: '',
        start_money: '',
        end_money: ''
      }
      this.time = []
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 选择时间事件
    onChangeTime (dateStrings) {
      this.time = dateStrings
      if (dateStrings.length !== 0) {
        this.queryParam.start_time = dateStrings[0].format('YYYY-MM-DD 00:00:00')
        this.queryParam.end_time = dateStrings[1].format('YYYY-MM-DD 23:59:59')
      } else {
        this.queryParam.start_time = ''
        this.queryParam.end_time = ''
      }
    },
    openModal (record) {
      this.doneShow = true
      this.item = record
    },
    openSetDoneModal (record) {
      this.setDoneShow = true
      this.item = record
    },
    setDone () {
      const data = {
        withdrawal_id: this.item.withdrawal_id,
        status: 'DONE',
        remark: this.item.setRemark
      }
      examine(data).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.setDoneShow = false
          this.$refs.table.refresh(true)
        }
      })
    },
    setRefuse () {
      const data = {
        withdrawal_id: this.item.withdrawal_id,
        status: 'REFUSE',
        remark: this.item.setRemark
      }
      if (data.remark === '' || data.remark === undefined) {
        this.$message.error('拒绝理由必填')
        return false
      }
      console.log(data.remark)
      examine(data).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.setRefuseShow = false
          this.$refs.table.refresh(true)
        }
      })
    },
    openSetRefuseModal (record) {
      this.setRefuseShow = true
      this.item = record
    },
    openRefuseModal (record) {
      this.refuseShow = true
      this.item = record
    },
    // 导出
    clickOrderOutExcel () {
      setTimeout(function() {
        window.location.href = window.location.origin + '/admin.php/withdrawal/outExcel'
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
